var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex td_footer_follow_us"},_vm._l((_vm.list),function(ref){
var name = ref.name;
var link = ref.link;
var icon = ref.icon;
return _c('li',{staticClass:"mr-4"},[_c('a',{staticClass:"hover:opacity-75",attrs:{"target":"_blank","href":link},on:{"click":function($event){return _vm.$emit("item-click", name)}}},[_c('i',{staticClass:"text-lg",class:icon,attrs:{"aria-hidden":"true","title":name}}),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(name))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }